import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Acesso negado com o motivo informado pelo backend (catálogo/Engine). */
export default function AccessDenied({ title = "Acesso não autorizado", reason }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-[320px] flex items-center justify-center p-6" data-testid="access-denied">
      <div className="w-full max-w-lg rounded-2xl border border-border bg-card p-8 text-center shadow-sm">
        <ShieldCheck className="mx-auto h-10 w-10 text-primary mb-4" aria-hidden="true" />
        <h2 className="font-heading text-xl font-semibold">{title}</h2>
        <p className="mt-2 text-sm text-muted-foreground" data-testid="access-denied-reason">
          {reason || "Seu usuário não possui autorização para este módulo."}
        </p>
        <p className="mt-1 text-xs text-muted-foreground">
          A autorização é decidida pelo servidor; procure o administrador da sua empresa.
        </p>
        <Button type="button" className="mt-6" onClick={() => navigate("/")} data-testid="access-denied-back">
          Ir para o início
        </Button>
      </div>
    </div>
  );
}
